import { Outlet, Navigate } from "react-router-dom";
import { useContext } from "react";
import React from "react";
import AuthContext from "../context/AuthContext";

import { Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import RegisterPage from "../pages/RegisterPage";

const PrivateRoute = ({children, ...rest}) => {
    let {user} = useContext(AuthContext)
    return (
        !user ? <Navigate to='/login' /> : <Outlet {...rest}>{children}</Outlet>
    )
}

export default PrivateRoute;